import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-692 (5.2 handoff).
export const OfferScreen = () => (
  <StubScreen id="offer" heading="Ihr Angebot" />
);
